export const getAlphabetsFromAscii = (index, baseAscii = 65) => {
  const asciiValue = index + baseAscii; // 65 represents the ASCII value of 'A'

  // Convert ASCII value to character
  const character = String.fromCharCode(asciiValue);
  return character;
};
